export var BogMerchantTypeEnum;
(function (BogMerchantTypeEnum) {
    BogMerchantTypeEnum["CARD_TO_CARD"] = "CARD_TO_CARD";
    BogMerchantTypeEnum["CARD_TO_CASH"] = "CARD_TO_CASH";
    BogMerchantTypeEnum["PAYMENT"] = "PAYMENT";
    BogMerchantTypeEnum["ACQUIRING"] = "ACQUIRING";
    BogMerchantTypeEnum["ACCOUNT_TO_CARD"] = "ACCOUNT_TO_CARD";
})(BogMerchantTypeEnum || (BogMerchantTypeEnum = {}));
//# sourceMappingURL=bog-merchant-type.enum.js.map